import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { theme } from './theme/theme';
import Routes from './Routes';

import { configureStore } from './store/configureStore';
import { ReduxieService } from './services/reduxieService';
import { Provider } from 'react-redux';

import { CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  spinner: {
    margin: 'auto auto auto auto',
  },
}));

export default function AppComponent(): JSX.Element {
  const history = useHistory();
  const classes = useStyles();

  const [store, setStore] = React.useState<any>(undefined);

  React.useEffect(() => {
    ReduxieService.loadState()
      .then((initialState) => {
        setStore(configureStore(history, initialState));
      })
      .catch(() => {
        // We assume that this fails because the database is not yet initialized
        console.info('Failed to load indexedDB, setting up new store');
        setStore(configureStore(history));
      });
  }, []);

  return (
    <React.Fragment>
      <Helmet titleTemplate="%s | LogStackPro" defaultTitle="LogStackPro" />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {store ? (
          <Provider store={store}>
            <Routes />
          </Provider>
        ) : (
          <CircularProgress
            color="secondary"
            size={'6rem'}
            className={classes.spinner}
          />
        )}
      </ThemeProvider>
    </React.Fragment>
  );
}
